export const CONFIG = {
  // * # Build vars
  ENVIRONMENT:
    globalThis?.import_meta_env?.VUE_APP_ENVIRONMENT ||
    process.env.VUE_APP_ENVIRONMENT,
  VERSION:
    globalThis?.import_meta_env?.VUE_APP_VERSION || process.env.VUE_APP_VERSION,
  GIT_COMMIT:
    globalThis?.import_meta_env?.VUE_APP_GIT_COMMIT ||
    process.env.VUE_APP_GIT_COMMIT,
  GIT_BRANCH:
    globalThis?.import_meta_env?.VUE_APP_GIT_BRANCH ||
    process.env.VUE_APP_GIT_BRANCH,
  // * # App
  // * # Sidebar navigation
  LOGO_HREF:
    globalThis?.import_meta_env?.VUE_APP_LOGO_HREF ||
    process.env.VUE_APP_LOGO_HREF,
  WALLETS_URL:
    globalThis?.import_meta_env?.VUE_APP_WALLETS_URL ||
    process.env.VUE_APP_WALLETS_URL,
  POOL_URL:
    globalThis?.import_meta_env?.VUE_APP_POOL_URL ||
    process.env.VUE_APP_POOL_URL,
  COINHOLD_URL:
    globalThis?.import_meta_env?.VUE_APP_COINHOLD_URL ||
    process.env.VUE_APP_COINHOLD_URL,
  P2P_URL:
    globalThis?.import_meta_env?.VUE_APP_P2P_URL || process.env.VUE_APP_P2P_URL,
  // * # AuthService
  AUTH_URL:
    globalThis?.import_meta_env?.VUE_APP_AUTH_URL ||
    process.env.VUE_APP_AUTH_URL,
  REGISTRATION_URL:
    globalThis?.import_meta_env?.VUE_APP_REGISTRATION_URL ||
    process.env.VUE_APP_REGISTRATION_URL,
  SUSPENDED_URL:
    globalThis?.import_meta_env?.VUE_APP_SUSPENDED_URL ||
    process.env.VUE_APP_SUSPENDED_URL,
  ALLOWED_COOKIE_DOMAIN:
    globalThis?.import_meta_env?.VUE_APP_ALLOWED_COOKIE_DOMAIN ||
    process.env.VUE_APP_ALLOWED_COOKIE_DOMAIN,
  // * # ApiService
  API_URL:
    globalThis?.import_meta_env?.VUE_APP_API_URL || process.env.VUE_APP_API_URL,
  ENDPOINT_API_URL:
    globalThis?.import_meta_env?.VUE_APP_ENDPOINT_API_URL ||
    process.env.VUE_APP_ENDPOINT_API_URL,
  EMCD_API_URL:
    globalThis?.import_meta_env?.VUE_APP_EMCD_API_URL ||
    process.env.VUE_APP_EMCD_API_URL,
  RATES_API_URL:
    globalThis?.import_meta_env?.VUE_APP_RATES_API_URL ||
    process.env.VUE_APP_RATES_API_URL,
  COMMON_API_URL:
    globalThis?.import_meta_env?.VUE_APP_COMMON_API_URL ||
    process.env.VUE_APP_COMMON_API_URL,
  // * # AnalyticsService
  SENTRY_DSN:
    globalThis?.import_meta_env?.VUE_APP_SENTRY_DSN ||
    process.env.VUE_APP_SENTRY_DSN,
  SENTRY_DEBUG:
    globalThis?.import_meta_env?.VUE_APP_SENTRY_DEBUG ||
    process.env.VUE_APP_SENTRY_DEBUG,
  STRAPI_API_URL:
    globalThis?.import_meta_env?.VUE_APP_STRAPI_API_URL ||
    process.env.VUE_APP_STRAPI_API_URL,
  GTM_ID:
    globalThis?.import_meta_env?.VUE_APP_GTM_ID || process.env.VUE_APP_GTM_ID,
  INTERCOM_APP_ID:
    globalThis?.import_meta_env?.VUE_APP_INTERCOM_APP_ID ||
    process.env.VUE_APP_INTERCOM_APP_ID,
  SEGMENT_ID:
    globalThis?.import_meta_env?.VUE_APP_SEGMENT_ID ||
    process.env.VUE_APP_SEGMENT_ID,
  BASE_URL:
    globalThis?.import_meta_env?.VUE_APP_BASE_URL ||
    process.env.VUE_APP_BASE_URL,
  GROUP_IB_ID:
    globalThis?.import_meta_env?.VUE_APP_GROUP_IB_ID ||
    process.env.VUE_APP_GROUP_IB_ID,
  // * # FeatureToggleService
  UNLEASH_URL:
    globalThis?.import_meta_env?.VUE_APP_UNLEASH_URL ||
    process.env.VUE_APP_UNLEASH_URL,
  UNLEASH_CLIENT_KEY:
    globalThis?.import_meta_env?.VUE_APP_UNLEASH_CLIENT_KEY ||
    process.env.VUE_APP_UNLEASH_CLIENT_KEY,
  EXPLORER_URL:
    globalThis?.import_meta_env?.VUE_APP_EXPLORER_URL ||
    process.env.VUE_APP_EXPLORER_URL,
  TRANSLATE_API_URL:
    globalThis?.import_meta_env?.VUE_APP_TRANSLATE_API_URL ||
    process.env.VUE_APP_TRANSLATE_API_URL,
  TRANSLATE_API_KEY:
    globalThis?.import_meta_env?.VUE_APP_TRANSLATE_API_KEY ||
    process.env.VUE_APP_TRANSLATE_API_KEY,
  TRANSLATE_UPDATE_INTERVAL_MS:
    globalThis?.import_meta_env?.VUE_APP_TRANSLATE_UPDATE_INTERVAL_MS ||
    process.env.VUE_APP_TRANSLATE_UPDATE_INTERVAL_MS,
};

export default CONFIG;
